import React from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '../context/ThemeContext';

export const AppToaster = () => {
  const { isDark } = useTheme();

  return (
    <Toaster
      position="top-right"
      richColors
      theme={isDark ? 'dark' : 'light'}
      toastOptions={{
        duration: 3000,
        classNames: {
          toast:
            'group toast border border-slate-200 bg-white text-slate-900 shadow-lg dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100',
          title: 'font-semibold',
          description: 'text-primary-700 dark:text-primary-200',
          actionButton:
            'bg-primary-500 text-white hover:bg-primary-600 dark:bg-primary-500 dark:text-white dark:hover:bg-primary-600',
          cancelButton:
            'bg-primary-100 text-primary-800 hover:bg-primary-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700',
        },
      }}
    />
  );
};

export default AppToaster;
